/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-17, 09:39:21
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-25, 12:35:03
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// Vuex Payment module mutations types

export const FILL_PAYMENT_PARAMS = 'FILL_PAYMENT_PARAMS';
export const SET_TOKEN_VALIDATION_STATE = 'SET_TOKEN_VALIDATION_STATE';
export const FILL_SALES_SERVICE_POINT_DATA = 'FILL_SALES_SERVICE_POINT_DATA';
export const SET_GATEWAY_URL = 'SET_GATEWAY_URL';
export const TOGGLE_WAITING_FOR_REDIRECTION_TO_GATEWAY = 'TOGGLE_WAITING_FOR_REDIRECTION_TO_GATEWAY';
export const TOGGLE_WAITING_FOR_SALES_SERVICE_POINT_DATA = 'TOGGLE_WAITING_FOR_SALES_SERVICE_POINT_DATA';
export const ENABLE_SUBMIT_PAYMENT = 'ENABLE_SUBMIT_PAYMENT';
export const DISABLE_SUBMIT_PAYMENT = 'DISABLE_SUBMIT_PAYMENT';
export const SET_SELECTED_GATEWAY = 'SET_SELECTED_GATEWAY';
export const SET_CREDIT_CARD_DATA = 'SET_CREDIT_CARD_DATA';
export const SET_SINGLE_USE_TOKEN = 'SET_SINGLE_USE_TOKEN';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_SUBSCRIPTION_PARAMS = 'SET_SUBSCRIPTION_PARAMS';



// WEBPACK FOOTER //
// ./src/store/modules/Payment/mutations-types.js